<template>
  <div class="wrapper"><!-- HEADER -- BLOCK MAIN -->
    <header class="header">
      <div class="container header__container">
        <div class="header__logo">
          <img loading="lazy" src="~@/assets/img/svg/logo.svg" class="image" width="105px" height="11px" alt="logo TARO IRENA" />
        </div>
        <div class="header__content list-reset">
          <h1 class="header__title list-reset">Этот тест определит ваш уровень энергии любви с точностью</h1>
          <p class="header__subtitle list-reset">97%!</p>
          <picture>
            <source srcset="~@/assets/img/love.avif" type="image/avif">
            <source srcset="~@/assets/img/love.webp" type="image/webp">
            <img loading="lazy" src="img/love.png" class="image" width="377" height="287" alt="Love">
          </picture>
          <p class="header__text list-reset">Вам потребуется <span>всего 6 минут,</span> чтобы узнать, как решить
            проблемы<br>в личной жизни, обрести настоящую любовь и здоровые отношения.
          </p>
          <a href="javascript:void(0)" @click="goTest" class="header__btn btn list-reset">Пройти тест</a>
        </div>
      </div>
    </header>
    <main class="main"><!-- RESULT -- BLOCK MAIN -->
      <section class="result">
        <div class="container result__container">
          <div class="result__content list-reset">
            <div class="content__item--one"><h2 class="item__title blue">11 К+</h2>
              <p class="item__text">женщин прошли этот тест</p></div>
            <div class="content__item--two"><h2 class="item__title purple">97%</h2>
              <p class="item__text">подтвердили достоверность результатов</p></div>
            <div class="content__item--thee"><h2 class="item__title orange">78%</h2>
              <p class="item__text">повысили свой уровень<br>благодаря советам после теста</p></div>
            <picture>
              <source srcset="~@/assets/img/vopros.avif" type="image/avif">
              <source srcset="~@/assets/img/vopros.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/vopros.png" class="image" width="274" height="234" alt="vopros">
            </picture>
            <div class="content__block list-reset"><h3 class="block__title">Кому необходимо пройти тест?</h3>
              <div class="line-block"></div>
              <div class="block__item"><span class="block__item--title">01</span>
                <p class="block__item--text">Женщинам, которые не могут встретить своего мужчину и мучаются
                  от одиночества.</p></div>
              <div class="block__item"><span class="block__item--title">02</span>
                <p class="block__item--text">Женщинам, которые постоянно выбирают не тех партнеров и
                  страдают от последствий своего выбора.</p></div>
              <div class="block__item"><span class="block__item--title">03</span>
                <p class="block__item--text">Женщинам, которым не хватает уверенности в себе и своем
                  спутнике.</p></div>
              <div class="block__item"><span class="block__item--title">04</span>
                <p class="block__item--text">Женщинам, которые устали искать внимания и интереса со стороны
                  мужчин.</p></div>
            </div>
          </div>
          <a href="javascript:void(0)" @click="goTest" class="result__btn btn list-reset">Пройти тест</a>
        </div>
      </section><!-- LEVELS -- BLOCK MAIN -->
      <section class="levels">
        <div class="container levels__container">
          <div class="levels__content list-reset">
            <h2 class="levels__title">Почему тест “Уровни энергии любви” так эффективен?</h2>
            <ul class="levels__list">
              <li class="levels__list--item">Это авторский тест Ирэны<br>Ивановой — таролога с 32-летним стажем.</li>
              <li class="levels__list--item">Она провела более 10 тысяч консультаций по теме отношений<br>и на основе своего опыта создала классификацию уровней<br>любовной энергии.</li>
              <li class="levels__list--item">Опросник теста также<br>сформирован Ирэной. Как профессиональный маг, она точно знает, какие вопросы помогают определить уровень любовной энергии и выявить слабые<br>стороны в любом конкретном<br>случае.</li>
              <li class="levels__list--item">А как опытный таролог, Ирэна<br>знает, как быстро поднять каждый уровень до следующего.</li>
              <li class="levels__list--item">Поэтому под каждым<br>результатом она делится своими рекомендациями, чтобы помочь женщинам выйти на новый<br>уровень и улучшить свою<br>личную жизнь в разы!</li>
            </ul>
            <a href="javascript:void(0)" @click="goTest" class="levels__btn btn list-reset">Пройти тест</a>
          </div>
        </div>
      </section><!-- Author -- BLOCK MAIN -->
      <section class="author">
        <div class="container author__container">
          <div class="author__content">
            <picture>
              <source srcset="~@/assets/img/author.avif" type="image/avif">
              <source srcset="~@/assets/img/author.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/author.png" class="image" width="358" height="299" alt="Author irena">
            </picture>
            <h2 class="author__title">Авторский тест <span>Ирэны Ивановой!</span></h2>
            <div class="author__block"><h3 class="author__subtitle">Главное об Ирэне:</h3>
              <div class="author__block--item">Таролог №1 в России</div>
              <div class="author__block--item">Таро-диагност с 32-летним<br>стажем</div>
              <div class="author__block--item">Более 100 000 проведенных<br>таро-консультаций</div>
              <div class="author__block--item">Профессиональный маг</div>
              <div class="author__block--item">Опытный эзотерик</div>
              <div class="author__block--item">Создатель уникальных<br>предметов силы</div>
            </div>
            <a href="javascript:void(0)" @click="goTest" class="author__btn btn" onclick="ym(56736205,'reachGoal','startlovetest')">Пройти тест</a>
          </div>
        </div>
      </section><!-- LEVEL-LOVE -- BLOCK MAIN -->
      <section class="levels-love energy">
        <div class="container energy__container">
          <div class="energy__content">
            <picture>
              <source srcset="~@/assets/img/levels.avif" type="image/avif">
              <source srcset="~@/assets/img/levels.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/levels.png" class="image" width="180" height="180" alt="Author irena">
            </picture>
            <h2 class="energy__title">Уровни энергии любви</h2>
            <p class="energy__text">Уровень вашей любовной энергии определяет, насколько вы любите себя и
              окружающих, а также — насколько другие люди могут любить вас. В течение жизни этот уровень можно
              менять, переходя на другой, однако сначала следует выявить свою изначальную точку.
            </p>
            <div class="energy__block">
              <h3 class="energy__block--title">Всего существует 6 уровней энергии любви:</h3>
              <div class="energy__block--item">
                <div class="block__item--left">
                  <p class="item__left--number">01</p>
                  <picture>
                    <source srcset="~@/assets/img/level-1.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-1.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-1.png" class="image" width="39" height="112" alt="Author irena">
                  </picture>
                </div>
                <div class="block__item--right"><h3 class="item__right--title">Болезненный:</h3>
                  <p class="item__right--text">проявляется тотальным одиночеством, неспособностью уважать и любить себя.</p></div>
              </div>
              <div class="energy__block--item two">
                <div class="block__item--left"><p class="item__left--number">02</p>
                  <picture>
                    <source srcset="~@/assets/img/level-2.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-2.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-2.png" class="image" width="39" height="112" alt="Author irena"></picture>
                </div>
                <div class="block__item--right">
                  <h3 class="item__right--title">Низкий:</h3>
                  <p class="item__right--text">выражается в полном отсутствии веры в себя и в позиции жертвы в отношениях.</p>
                </div>
              </div>
              <div class="energy__block--item thee">
                <div class="block__item--left">
                  <p class="item__left--number">03</p>
                  <picture>
                    <source srcset="~@/assets/img/level-3.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-3.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-3.png" class="image" width="39" height="112" alt="Author irena">
                  </picture>
                </div>
                <div class="block__item--right">
                  <h3 class="item__right--title">Недостаточный:</h3>
                  <p class="item__right--text">указывает на низкую самооценку и невозможность осознать свои достоинства.</p>
                </div>
              </div>
              <div class="energy__block--item four">
                <div class="block__item--left">
                  <p class="item__left--number">04</p>
                  <picture>
                    <source srcset="~@/assets/img/level-4.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-4.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-4.png" class="image" width="39" height="112" alt="Author irena">
                  </picture>
                </div>
                <div class="block__item--right">
                  <h3 class="item__right--title">Средний:</h3>
                  <p class="item__right--text">проявляется дефицитом уверенности в себе, непостоянством и
                    нестабильностью.</p>
                </div>
              </div>
              <div class="energy__block--item five">
                <div class="block__item--left"><p class="item__left--number">05</p>
                  <picture>
                    <source srcset="~@/assets/img/level-5.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-5.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-5.png" class="image" width="39" height="112" alt="Author irena">
                  </picture>
                </div>
                <div class="block__item--right">
                  <h3 class="item__right--title">Достаточный:</h3>
                  <p class="item__right--text">описывает здоровую ресурсность и одновременно высокие требования к партнеру.</p>
                </div>
              </div>
              <div class="energy__block--item six">
                <div class="block__item--left"><p class="item__left--number">06</p>
                  <picture>
                    <source srcset="~@/assets/img/level-6.avif" type="image/avif">
                    <source srcset="~@/assets/img/level-6.webp" type="image/webp">
                    <img loading="lazy" src="~@/assets/img/level-6.png" class="image" width="39" height="112" alt="Author irena">
                  </picture>
                </div>
                <div class="block__item--right six-item">
                  <h3 class="item__right--title">Высокий:</h3>
                  <p class="item__right--text six-text">обозначает наивысший уровень любовной энергии, предполагающий способность любить безусловно.</p>
                </div>
              </div>
            </div>
            <a href="javascript:void(0)" @click="goTest" class="energy__btn btn" onclick="ym(56736205,'reachGoal','startlovetest')">Узнать свой уровень</a>
          </div>
        </div>
      </section><!-- REVIEWS -- BLOCK MAIN -->
      <section class="reviews">
        <div class="container reviews__container">
          <div class="reviews__content">
            <h2 class="reviews__title">Отзывы о тесте</h2>
            <div class="reviews__block">
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Александра</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">У меня низкий уровень. Я так и предполагала. Нет у меня веры
                  в себя, очень сложно что-то менять. Чувствую себя одинокой, хоть и состою в отношениях.
                  Удивительно, какой точный тест. Буду работать над собой. Теперь ведь есть для этого
                  инструменты. Огромное вам спасибо!
                </p>
              </div>
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Екатерина</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">Супер!! Невероятно точно!! Совпало каждое слово😍 Как же
                  много зависит от уровня энергии. Я теперь лучше понимаю себя. Посмотрела на себя другими
                  глазами. Буду следовать рекомендациям обязательно. Было очень-очень полезно.
                  Спасибо😘🌺🌺🌺
                </p>
              </div>
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Мария</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">Вот откуда это постоянное чувство недостаточности. Я уже
                  проговариваю аффирмации))) Очень хочется поменять уже все в жизни. А теперь я вижу, как
                  много значит уровень энергии, как много от него зависит. Буду всем рекомендовать этот
                  тест. У меня много знакомых, которым это точно необходимо!
                </p>
              </div>
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Кира</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">Благодарю сердечно за тест ❤️❤️❤️ Результатом не удивлена,
                  так и чувствовала, прямо в точку! Теперь знаю, что делать дальше, чтобы изменить
                  ситуацию. Мне очень помогли советы. Буду действовать! И всем рекомендую!
                </p>
              </div>
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Александра</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">У меня низкий уровень. Я так и предполагала. Нет у меня веры
                  в себя, очень сложно что-то менять. Чувствую себя одинокой, хоть и состою в отношениях.
                  Удивительно, какой точный тест. Буду работать над собой. Теперь ведь есть для этого
                  инструменты. Огромное вам спасибо!
                </p>
              </div>
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Светлана</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">Очень точно! Огромное спасибо вам за этот тест. У меня не
                  такая уж плохая ситуация, но все же очень хочется теперь стремиться к самому высокому
                  уровню энергии. Особая благодарность за рекомендации! Уже выполняю!
                </p>
              </div>
              <div class="reviews__block--item">
                <h3 class="reviews__item--title">Татьяна</h3>
                <div class="reviews__item--line"></div>
                <p class="reviews__item--text">Тест очень удивил. Не ожидала такой точности. Результат
                  полностью совпадает с моим ощущением себя. У меня средний уровень энергии любви. Так и
                  есть. Я действительно, то красавица и богиня, то лучше бы никого не встретить
                  сегодня😂
                </p>
              </div>
            </div>
            <a href="javascript:void(0)" @click="goTest" class="reviews__btn btn list-reset">Пройти тест</a>
          </div>
        </div>
      </section>
    </main>
    <footer class="footer">
      <div class="container"></div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
  components: {},
  methods: {
    removeParam(key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
          param, params_arr = [],
          queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },
    goTest(){
      ym(56736205,'reachGoal','startlovetest')
      return this.$router.push({ name: 'quiz' })
    }
  },
  mounted() {
    let store = this.$store
    let utmList = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ];
    let urlObject = {};
    let utmObj = {};

    try {
      urlObject = new URL(window.location.href);
      for (let utmItem of utmList) {
        utmObj[utmItem] = "";
        let val = urlObject.searchParams.get(utmItem);
        if (val) {}
        else {
          let itemUtm = localStorage.getItem(utmItem)
          if(itemUtm) {
            store.commit('setUtm', {type: utmItem, items: itemUtm})
          }
        }
      }
    }
    catch (e) {
      console.log("e: ", e);
    }
    //?utm_source=Website&utm_medium=cpc&utm_campaign=quiz_test&utm_content=lending
  }
}
</script>
